<div class="flex flex-col lg:flex-row lg:gap-64">
    <div class="flex flex-col gap-8 py-16 lg:max-w-[600px] lg:flex-1">
        @for (item of vehicle().vehicleData; track $index) {
            @if (
                (item.key !== 'HU' && item.key !== 'TÜV/AU Neu') ||
                (item.key === 'TÜV/AU Neu' && vehicleHasTuv()) ||
                (item.key === 'HU' && !vehicleHasTuv() && vehicleHasHu())
            ) {
                <lib-key-value [key]="item.key" [value]="item.value" />
            }
        }
    </div>

    <hr class="my-8 lg:hidden" />

    <div class="flex flex-col gap-8 py-16 lg:flex-1 lg:basis-1/3 lg:flex-row lg:gap-32">
        <div class="flex flex-col gap-8 lg:flex-1">
            <h4 class="text-20 leading-25">Umwelt- & Energiedaten</h4>
            @for (envkv of vehicle().envkv; track $index) {
                @if (envkv.value) {
                    <lib-key-value [key]="envkv.label" [value]="envkv.value + ' ' + envkv.unit" />
                }
            }
        </div>

        @if (envkvImage(); as image) {
            <div>
                @if (isPluginHybrid()) {
                    <ui-m000-c010-image
                        class="block h-[220px] w-[300px] lg:h-[180px] lg:w-[246px]"
                        [classList]="'w-full h-[220px] w-[300px] lg:h-[180px] lg:w-[246px]'"
                        [image]="{
                            image: image,
                            desktop: { width: 246, height: 180 },
                            tablet: { width: 246, height: 180 },
                            mobile: { width: 300, height: 220 },
                        }"
                        [priority]="false"
                        [alt]="'Enkv Icon'"
                        highRes
                    />
                } @else {
                    <ui-m000-c010-image
                        class="block h-[180px] w-[300px] lg:h-[148px] lg:w-[246px]"
                        [classList]="'w-full h-[180px] w-[300px] lg:h-[148px] lg:w-[246px]'"
                        [image]="{
                            image: image,
                            desktop: { width: 246, height: 148 },
                            tablet: { width: 246, height: 148 },
                            mobile: { width: 300, height: 180 },
                        }"
                        [priority]="false"
                        [alt]="'Enkv Icon'"
                        highRes
                    />
                }
            </div>
        }
    </div>
</div>
